import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { ArrowLeft, MessageCircle } from "lucide-react";

export default function CheckoutCancelPage() {
  const [params] = useSearchParams();
  const productId = params.get("product_id");
  const [whatsapp, setWhatsapp] = useState("");

  useEffect(() => {
    api
      .get("/config")
      .then(({ data }) => setWhatsapp(data?.whatsapp_number || ""))
      .catch(() => setWhatsapp(""));
  }, []);

  const waText = encodeURIComponent("Hi, I had questions before checking out. Can you help me?");
  const waUrl = whatsapp ? `https://wa.me/${whatsapp}?text=${waText}` : `https://wa.me/?text=${waText}`;

  return (
    <main className="bg-leaf-pattern min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12" data-testid="checkout-cancel-page">
      <Card className="w-full max-w-lg rounded-2xl border-emerald-100">
        <CardContent className="p-8 text-center">
          <h1 className="font-display text-3xl text-emerald-950">Checkout cancelled</h1>
          <p className="text-emerald-900/70 mt-2">
            No worries — nothing was charged. Take your time. If you have any questions, our team
            is one tap away.
          </p>
          <div className="mt-6 flex gap-3 justify-center flex-wrap">
            <Link to="/report" data-testid="cancel-back-link">
              <Button className="rounded-full bg-emerald-700 hover:bg-emerald-800 text-white">
                <ArrowLeft className="w-4 h-4 mr-1" /> Back to my plan
              </Button>
            </Link>
            <a href={waUrl} target="_blank" rel="noreferrer noopener" data-testid="cancel-wa-link">
              <Button className="rounded-full bg-amber-400 hover:bg-amber-500 text-emerald-950">
                <MessageCircle className="w-4 h-4 mr-1" /> Chat with an expert
              </Button>
            </a>
          </div>
          {productId ? (
            <div className="mt-3 text-xs text-emerald-900/50">Product ref: {productId}</div>
          ) : null}
          <div className="mt-6 text-[11px] text-emerald-900/60">
            By continuing you agree to our{" "}
            <Link to="/terms" className="underline hover:text-emerald-700" data-testid="cancel-terms-link">Terms</Link>{" "}
            ·{" "}
            <Link to="/privacy" className="underline hover:text-emerald-700" data-testid="cancel-privacy-link">Privacy Policy</Link>{" "}
            ·{" "}
            <Link to="/refund" className="underline hover:text-emerald-700" data-testid="cancel-refund-link">Refund Policy</Link>
          </div>
        </CardContent>
      </Card>
    </main>
  );
}
